/** Created by azhou on 2019/3/29.*/
<template>
  <div>
    <group-room-meet-list v-if="isGroup && !storeId"/>
    <store-cld-lists v-else/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupRoomMeetList from './GroupRMCList'
  import StoreCldLists from './StoreCldLists'

  export default {
    name: 'GroupCalendarBus',
    components: { GroupRoomMeetList, StoreCldLists },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.storeId },
    }
  }
</script>
